import React from "react";
import {
  Pagination,
  PaginationItem,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import { Footer } from "../../../container/Internal/Footer";

const StyledStack = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  borderRadius: `${theme.shape.borderRadius}px`,
  padding: "5px 15px",
  height: 36.5,
  alignItems: "center",
  justifyItems: "center",
  flexDirection: "row",
  gap: theme.spacing(1),
}));

const PreviousUI = () => (
  <StyledStack>
    <WestIcon fontSize="small" />
    <Typography>Previous</Typography>
  </StyledStack>
);

const NextUI = () => (
  <StyledStack>
    <Typography>Next</Typography>
    <EastIcon fontSize="small" />
  </StyledStack>
);

const PaginationUI = ({ count, page, onChange }) => (
  <Footer
    sx={{
      [`& .MuiToolbar-root`]: {
        justifyContent: "center",
      },
    }}
  >
    <Pagination
      variant="outlined"
      shape="rounded"
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiPagination-ul": {
          width: "100%",
          alignItems: "center",
          "& li .MuiButtonBase-root.MuiPaginationItem-page": {
            background: "#FFFFFF",
            boxShadow: "0px 1px 2px 0px #1018280D",
            "&.Mui-selected": {
              background: "#101828",
              color: "#FFFFFF",
            },
          },
          "& li .MuiButtonBase-root.MuiPaginationItem-previousNext": {
            flexGrow: 1,
            border: "0px solid #DBDDE0",
            "&.Mui-disabled": {
              opacity: 0,
            },
          },
        },
      }}
      onChange={onChange}
      count={count}
      page={page}
      boundaryCount={3}
      renderItem={(item) => (
        <PaginationItem
          slots={{ previous: PreviousUI, next: NextUI }}
          {...item}
        />
      )}
    />
  </Footer>
);

export default React.memo(PaginationUI);
